<template>
  <!-- MODAL CSS -->
  <div class="modal fade" :id="id" tabindex="-1" :aria-labelledby="id + 'Label'" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <p class="modal-title typography-headline-md fw-500" :id="id + 'Label'">CSS</p>
          <button type="button" class="btn-close img-logo" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="table-responsive">
            <table class="table table-hover table-borderless">
              <thead>
              <tr>
                <th scope="col">Orientation</th>
                <th scope="col">CSS (Click text to copy. If you can't copy, just hit Ctrl+C)</th>
              </tr>
              </thead>
              <tbody>

              <!-- ORIENTATION CUSTOM -->
              <tr v-if="gradient.gradientType" class="align-middle">
                <th scope="row"><i class="material-icons-outlined text-secondary mdc-18 me-2">rotate_90_degrees_ccw</i>
                  {{ gradient.gradientRotation }}
                </th>
                <td v-if="gradient.color3" class="text-lowercase">
                  <code class="selector-gradient text-underline">background: {{ gradient.gradientType }}({{ gradient.gradientRotation }},
                    {{ gradient.color1 }}, {{ gradient.color2 }}, {{ gradient.color3 }});</code>
                </td>
                <td v-else class="text-lowercase">
                  <code class="selector-gradient text-underline">background: {{ gradient.gradientType }}({{ gradient.gradientRotation }},
                    {{ gradient.color1 }}, {{ gradient.color2 }};</code>
                </td>
              </tr>

              <!-- ORIENTATION DEFAULT -->
              <tr class="align-middle">
                <th scope="row"><i class="material-icons-outlined text-secondary mdc-18 me-2">arrow_right</i> To
                  Right
                </th>
                <td v-if="gradient.color3" class="text-lowercase">
                  <code class="selector-gradient text-underline">background: linear-gradient(to right, {{gradient.color1 }}, {{ gradient.color2 }},
                    {{ gradient.color3 }});</code>
                </td>
                <td v-else class="text-lowercase">
                  <code class="selector-gradient text-underline">background: linear-gradient(to right, {{ gradient.color1 }}, {{ gradient.color2 }});</code>
                </td>
              </tr>

              <tr class="align-middle">
                <th scope="row"><i
                    class="material-icons-outlined text-secondary mdc-18 me-2">arrow_left</i> To Left
                </th>
                <td v-if="gradient.color3" class="text-lowercase">
                  <code class="selector-gradient text-underline">background: linear-gradient(to left, {{ gradient.color1 }},
                    {{ gradient.color2 }},
                    {{ gradient.color3 }});</code>
                </td>
                <td v-else class="text-lowercase">
                  <code class="selector-gradient text-underline">background: linear-gradient(to left, {{ gradient.color1 }},
                    {{ gradient.color2 }});</code>
                </td>
              </tr>

              <tr class="align-middle">
                <th scope="row"><i
                    class="material-icons-outlined text-secondary mdc-18 me-2">arrow_drop_down</i>
                  To Bottom
                </th>
                <td v-if="gradient.color3" class="text-lowercase">
                  <code class="selector-gradient text-underline">background: linear-gradient(to bottom, {{gradient.color1 }}, {{ gradient.color2 }},
                    {{ gradient.color3 }});</code>
                </td>
                <td v-else class="text-lowercase">
                  <code class="selector-gradient text-underline">background: linear-gradient(to bottom, {{ gradient.color1 }}, {{ gradient.color2 }});</code>
                </td>
              </tr>

              <tr class="align-middle">
                <th scope="row"><i
                    class="material-icons-outlined text-secondary mdc-18 me-2">arrow_drop_up</i>
                  To Top
                </th>
                <td v-if="gradient.color3" class="text-lowercase">
                  <code class="selector-gradient text-underline">background: linear-gradient(to top, {{ gradient.color1 }},
                    {{ gradient.color2 }},
                    {{ gradient.color3 }});</code>
                </td>
                <td v-else class="text-lowercase">
                  <code class="selector-gradient text-underline">background: linear-gradient(to top, {{ gradient.color1 }},
                    {{ gradient.color2 }});</code>
                </td>
              </tr>

              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-link" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalGradientCss',
  props: [
    'gradient',
    'id'
  ],
  mounted() {
    this.copyCodeCSS()
  },
  methods: {
    copyCodeCSS() {
      const aioCss = document.querySelectorAll('.selector-gradient')
      aioCss.forEach(codeCss => {
        codeCss.addEventListener('click2', () => {
          const selectionCss = window.getSelection();
          const rangeCss = document.createRange();
          rangeCss.selectNodeContents(codeCss);
          selectionCss.removeAllRanges();
          selectionCss.addRange(rangeCss);

          try {
            document.execCommand('copy2');
            selectionCss.removeAllRanges();

            const originalCss = codeCss.textContent;
            codeCss.textContent = 'CSS Code Copied!';
            codeCss.classList.add('text-success');

            setTimeout(() => {
              codeCss.textContent = originalCss;
              codeCss.classList.remove('text-success');
            }, 1200);
          } catch (e) {
            const errorMsgCss = document.querySelector('.error-msg');
            errorMsgCss.classList.add('d-block');

            setTimeout(() => {
              errorMsgCss.classList.remove('d-block');
            }, 1200);
          }
        });
      });
    }
  }
}
</script>